export default __webpack_public_path__ + "static/visit-people-af9b70316392e6cadf95895ca95f1c13.svg";